import { gql } from 'graphql-request'

export const getUser = gql`
  query GetUser {
    me {
      id
      username
      full_name
      first_name
      last_name
      user_type{
        id
        type
      }
      token
      email
      active
      has_car
      job_title
      status
      time_credit
      entry_date
      exit_date
      internal_number
      open_holidays
      holiday_total
      holiday_carried_over
      hourly_wage
      expenses
      fixed_time
      daily_work_time
      hasToken
    }
  }
`